import Repository from "./Repository";

const resource = "/hearings";

export default {
  get(part, headers) {
    return Repository.get(`${resource}/${part}`, { headers });
  },
  post(body, headers) {
    return Repository.post(`${resource}`, body, { headers });
  },
};



// WEBPACK FOOTER //
// ./src/repositories/HearingsRepository.js